// Định nghĩa kiểu dữ liệu cho thông tin sắp xếp
export interface SortCriteria<T> {
    key: keyof T;
    order: 'asc' | 'desc';
}
export interface DetailsDataItem {
    daiId1: string;
    daiId2: string;
    diem: number;
    loaiCuocId: string
    quaCo: number;
    soCuoc: string
    thuong: number
    trung: number
}
// Hàm để sắp xếp mảng dựa trên nhiều tiêu chí
export function sortArray<T>(array: T[], criteria: SortCriteria<T>[]): T[] {
    return array.sort((a, b) => {
        for (let i = 0; i < criteria.length; i++) {
            const { key, order } = criteria[i];
            let comparison = 0;

            if (a[key] > b[key]) {
                comparison = 1;
            } else if (a[key] < b[key]) {
                comparison = -1;
            }

            if (comparison !== 0) {
                return order === 'asc' ? comparison : -comparison;
            }
        }
        return 0;
    });
}